import { computed } from "vue";
import {
  formatUsername,
  getInitials,
  getUserNameAndFallbacksFromRawData,
} from "@/utils/utils";
import { fetchJSON } from "./utils";
import { USER_STATUS } from "@/constants/user";

function formatUserData(user) {
  user._is_disabled = user.status == USER_STATUS.INCOMPLETE; // IMPT: getUserNameAndFallback uses this field to add '(Disabled)' prefix
  user._is_active = user.status == USER_STATUS.REGISTERED;

  const name = getUserNameAndFallbacksFromRawData(user);
  return {
    ...user,
    name,
    shortName: formatUsername(name),
    initials: getInitials(name),
  };
}

export async function fetchMyProfile(data) {
  const url = `/api/user/me`;
  const userData = await fetchJSON(url, null, data, "get");

  const formattedUserObj = formatUserData(userData.user);
  // shallow copy is ok because formattedUserObj is flat
  userData.user = { ...formattedUserObj };
  return userData;
}

export async function requestInvitationLink(data) {
  const url = `/api/user/request-invitation-link`;
  return fetchJSON(url, data, null, "get");
}

export async function fetchOne(userId) {
  const url = `/api/user/one`;
  if (!userId) {
    throw new Error("userId is required");
  }
  return fetchJSON(url, { id: userId }, null, "get");
}

export async function updateMyProfile(data) {
  const url = `/api/user/me`;
  return fetchJSON(url, null, data, "put");
}

/**
 * Fetches user list
 * @param {bool} only_hq specify if we want to fetch only the users who can be part of a department
 * @param {str} orgId optional, an organization id to filter the users
 * @returns
 */
export async function fetchUserList(only_hq = null, orgId = null) {
  const url = `/api/user/all`;
  let data = {};
  if (only_hq) {
    data = { only_hq };
  }
  if (orgId) {
    data = { organization_id: orgId };
  }
  const resp = await fetchJSON(url, data, null, "get", false);

  return resp.data.map(formatUserData);
}

// Fetch full info for one user
export function fetchAllUserFull(params) {
  const url = "/api/user/one_full";
  return fetchJSON(url, params, null, "get");
}

export function fetchAllUsersFull(params) {
  const url = "/api/user/all_full";
  return fetchJSON(url, params, null, "get");
}

export function createUser(data) {
  const url = "/api/user/create_full";
  return fetchJSON(url, null, data, "post");
}

export function createBulkUsers(data) {
  const url = "/api/user/create_bulk_full";
  return fetchJSON(url, null, data, "post");
}

export function inviteUser(data) {
  const url = "/api/user/invite";
  return fetchJSON(url, null, data, "post");
}

export function updateUsers(data) {
  const url = "/api/user/update_full";
  return fetchJSON(url, null, data, "put");
}

export function validateUserData(data) {
  const url = "/api/user/validate_data";
  return fetchJSON(url, null, data, "post");
}

export function updateTicketSettings(data) {
  const url = "/api/user/settings/ticket/update";
  return fetchJSON(url, null, data, "put");
}
